import styled from 'styled-components'

export const TextCapitalize = styled.span`
  text-transform: capitalize;
`

export const TextBold = styled.span`
  font-weight: bold;
`
